import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'range-slider-field',
  templateUrl: './range-slider-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RangeSliderFieldComponent {
  // labeled-field inputs/outputs
  @Input() label: string;
  @Input() help: string;
  @Input() required: boolean = false;
  @Input() actionText: string;
  @Input() labelDirection: 'row' | 'column' = 'column';
  @Output() action = new EventEmitter();

  // range-slider inputs/outputs
  @Input() lowerMin: number = 0;
  @Input() lowerMax: number = 0;
  @Input() upperMin: number = 0;
  @Input() upperMax: number = 0;
  @Input() type: 'number' | 'currency' | 'percent' = 'number';
  @Input() dragSignificantDigits: number = 2;
  @Input() value: [number, number] = [0, 0];
  @Output() valueChange = new EventEmitter<[number, number]>();
}
